module.exports = __webpack_public_path__ + "img/1.2898f1f8.jpg";